export default {"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19};